import React from 'react';
import FormModal from '../../../common/form/FormModal';
import I18n from '../../../common/i18n/I18n';
import { Typography } from '@mui/material';
import FormPanel from '../../../common/form/FormPanel';
import { FormContainer } from '../../../common/form/FormContainer';
import FormItem from '../../../common/form/FormItem';
import ShowrunnrAIButton from './ShowrunnrAIButton';
import ShowrunnrAI from '../../../common/icons/IconImages/ShowrunnrAI';

type ShowrunnrAIInfoModalProps = {
    isOpen: boolean;
    onClose: () => void;
};

export default ({ isOpen, onClose }: ShowrunnrAIInfoModalProps) => {
    return (
        <FormModal
            id={'showrunnrAI-info'}
            title={''}
            isOpen={isOpen}
            onClose={onClose}
            hideDefaultButtons
            closeOnBackdropClick
        >
            <FormPanel>
                <FormContainer>
                    <FormItem sx={{ justifyContent: 'center' }}>
                        <ShowrunnrAI />
                    </FormItem>
                </FormContainer>
                <FormContainer>
                    <FormItem>
                        <Typography fontSize={'24px'} fontWeight={'600'}>
                            <I18n token="showrunnrAI.title" />
                        </Typography>
                    </FormItem>
                </FormContainer>
                <FormContainer containerSx={{ pt: 1 }}>
                    <FormItem>
                        <Typography>
                            <I18n token="showrunnrAI.description.first" /> {<ShowrunnrAIButton />}
                            <I18n token="showrunnrAI.description.second" />
                        </Typography>
                    </FormItem>
                </FormContainer>
            </FormPanel>
        </FormModal>
    );
};
